import { BookOpen, Newspaper, Lightbulb, TrendingUp, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { SmartNotesMockup } from "@/components/marketing/SmartNotesMockup";

const tasks = [
  { Icon: Lightbulb, label: "Opportunity Summary" },
  { Icon: BookOpen, label: "Company Overview" },
  { Icon: Newspaper, label: "Recent News" },
  { Icon: TrendingUp, label: "Market Position" },
];

export const SmartNotes = () => {
  const { ref: textRef, animationClass: textAnim } = useScrollAnimation<HTMLDivElement>({
    type: "slide-up",
    threshold: 0.15,
  });
  const { ref: mockRef, animationClass: mockAnim } = useScrollAnimation<HTMLDivElement>({
    type: "slide-up",
    delay: 120,
    threshold: 0.15,
  });

  return (
    <section id="smart-notes" className="py-20 md:py-28 bg-surface-1/40">
      <div className="container px-4">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.1fr] gap-10 md:gap-14 items-center max-w-6xl mx-auto">
          {/* Text side */}
          <div ref={textRef} className={textAnim}>
            <span className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">
              Smart Notes
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mt-3 mb-5">
              Context, not just contacts.
            </h2>
            <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-6">
              Pick a research task and get a ready-to-paste note for the contact — pulled live from
              public web sources. No tab switching, no copy-paste research.
            </p>

            <ul className="space-y-2 mb-8">
              {tasks.map(({ Icon, label }) => (
                <li
                  key={label}
                  className="flex items-center gap-3 px-3.5 py-2.5 rounded-lg bg-card border border-border/60 hover:border-brand-blue/40 transition-colors"
                >
                  <div className="w-7 h-7 rounded-md bg-surface-2 border border-border/60 grid place-items-center flex-shrink-0">
                    <Icon className="w-3.5 h-3.5 text-foreground" strokeWidth={1.75} />
                  </div>
                  <span className="text-sm font-medium">{label}</span>
                </li>
              ))}
            </ul>

            <Link
              to="/pricing"
              className="inline-flex items-center gap-2 text-sm font-medium text-brand-blue hover:underline"
            >
              View plans
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Mockup side */}
          <div ref={mockRef} className={mockAnim}>
            <SmartNotesMockup />
          </div>
        </div>
      </div>
    </section>
  );
};
